export default __webpack_public_path__ + "static/media/stone_click.5e62ac71.mp3";